import React, { useEffect, useState } from 'react';
import ThemedIcon from '../../common/ThemedIcon';
import styled from 'styled-components';
import unchecked from '../../../images/refund-status-tele/unchecked.svg';
import userIcon from '../../../images/consultations/new-flow/user-icon.svg';
import clockIcon from '../../../images/lab-test/green-clock.svg';
import { fetchFeedbackConsultationInfo } from '../../../services';
import { useLocation } from 'react-router-dom';
import { showError } from '../../../utils';
import { setUserNameFeedback } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import crypto from 'crypto';

const OuterContainer = styled.div`
  position: relative;
  width: 80%;
  min-height: 170px;
  gap: 12px;
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  opacity: 0px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const ConsultationCard = styled.div`
  position: absolute;
  padding: 1px 4px 1px 4px;
  gap: 10px;
  border-radius: 0px 0px 8px 8px;
  opacity: 0px;
  background: #1eb865;
  top: 0px;
  left: 20px;
`;

const CardText = styled.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.25px;
  text-align: left;
  color: #ffffff;
`;

const DoctorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

// Function to decrypt the cid
function decryptCid(encryptedCid) {
  const algorithm = 'aes-256-cbc';
  const [iv, encryptedText, key] = encryptedCid
    .split(':')
    .map((part) => Buffer.from(part, 'hex'));

  let decipher = crypto.createDecipheriv(algorithm, Buffer.from(key), iv);
  let decrypted = decipher.update(encryptedText);
  decrypted = Buffer.concat([decrypted, decipher.final()]);

  return decrypted.toString();
}

const DoctorCard = ({ feedbackStatus, consulationChatContainer }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);
  const encryptedCid = params.get('cid');
  const consultationId = consulationChatContainer
    ? params.get('cid')
    : decryptCid(encryptedCid);

  const [consultationInfo, setConsultationInfo] = useState({});

  const getConsultationInfo = async () => {
    try {
      const data = await fetchFeedbackConsultationInfo({ consultationId });
      if (data.consultationInfo) {
        setConsultationInfo(data.consultationInfo);
        if (data.consultationInfo.patientName) {
          dispatch(setUserNameFeedback(data.consultationInfo.patientName));
        }
      }
    } catch (err) {
      showError(err);
    }
  };

  useEffect(() => {
    getConsultationInfo();
  }, []);

  return (
    <OuterContainer>
      <ConsultationCard>
        <CardText>Online Consultation</CardText>
      </ConsultationCard>
      <DoctorContainer
        style={{ borderBottom: '1px solid #E3E3E3', paddingBottom: '10px' }}
      >
        <img
          src={consultationInfo.profileImg}
          alt="doctorImg"
          height="60px"
          width="60px"
        />
        <div className="flex flex-col gap-0">
          <CardText
            style={{ fontSize: '14px', lineHeight: '24px', color: '#0F0B28' }}
          >
            {consultationInfo.doctorName}
          </CardText>
          <CardText
            style={{ fontSize: '11px', lineHeight: '24px', color: '#767787' }}
          >
            {consultationInfo.verticalName}
          </CardText>
        </div>
      </DoctorContainer>
      <InfoContainer>
        <div className="flex gap-2">
          <ThemedIcon src={userIcon} alt="user" />
          <CardText
            style={{ fontSize: '11px', lineHeight: '24px', color: '#767787' }}
          >
            Patient:{' '}
            <strong color="#0F0B28">
              {consultationInfo.patientName
                ? consultationInfo.patientName
                : 'User'}
            </strong>
          </CardText>
        </div>
        <div className="flex gap-2">
          <img src={clockIcon} alt="user" />
          <CardText
            style={{ fontSize: '11px', lineHeight: '24px', color: '#767787' }}
          >
            Appointment:{' '}
            <strong color="#0F0B28">{consultationInfo.createdAt}</strong>
          </CardText>
        </div>
      </InfoContainer>
    </OuterContainer>
  );
};

export default DoctorCard;
